export const FETCH_REQUESTED = "home_land/FETCH_REQUESTED"
export const FETCH_SUCCESS = "home_land/FETCH_SUCCESS"
export const FETCH_FAILED = "home_land/FETCH_FAILED"

export const FILTERS_UPDATED = "home_land/FILTERS_UPDATED"
export const FILTERS_UPDATED_NO_FETCH = "home_land/FILTERS_UPDATED_NO_FETCH"

export const CTRL_MODAL_FILTER = "home_land/CTRL_MODAL_FILTER"
